/* script */
//
//
//
//
//
//
//


import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';

const __vue_script__ = {
    name: 'RejectModal',

    components: {
        DialogComponent
    },

    props: {
        ids: {
            type: Array,
            required: true
        },

        event: {
            type: Object,
            required: true
        },

        onClose: {
            type: Function,
            default: () => {}
        },
    },

    data() {
        return {
            title: this.$t('meetings.requests.dialog.reject-request.title'),
            text: this.$t('meetings.requests.dialog.reject-request.text')
        };
    },

    computed: {
        buttons() {
            return [
                {
                    title: this.$t('general.cancel'),
                    class: 'btn',
                    handler: () => this.onClose(),
                },
                {
                    title: this.$t('meetings.requests.dialog.reject-request.without_notification'),
                    default: true,
                    handler: async () => {
                        await this.processMeetingRequestRejection({ notify: false });
                        this.onClose();
                    },
                    class: 'btn btn-danger'
                },
                {
                    title: this.$t('meetings.requests.dialog.reject-request.with_notification'),
                    default: true,
                    handler: async () => {
                        await this.processMeetingRequestRejection({ notify: true });
                        this.onClose();
                    },
                    class: 'btn btn-primary'
                }
            ];
        }
    },

    methods: {
        /**
         * Process meeting request rejection
         * Calls related app script to process meeting request rejection
         * in the pkg-meetings
         * @param notify boolean flag to send email to participants
         */
        async processMeetingRequestRejection({ notify }) {
            try {
                if (!this.ids?.length) {
                    console.warn('[RejectMeetingRequest] No ids to reject');
                    return;
                }
                await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'meeting-requests/reject-request',
                    { ids: this.ids, notify }
                );
                const successMessage = notify ?
                    'meetings.requests.notify.rejected_with_notification_success' :
                    'meetings.requests.notify.rejected_success';
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(successMessage).toString(),
                });
                await this.$emit('reload');
            } catch (error) {
                const failureMessage = notify ?
                    'meetings.requests.notify.rejected_with_notification_fail' :
                    'meetings.requests.notify.rejected_fail';
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t(failureMessage).toString(),
                    type: 'error'
                });
            }
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-component',{staticClass:"reject-modal",attrs:{"title":_vm.title,"text":_vm.text,"buttons":_vm.buttons}})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "RejectModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__